import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, MenuMappingService, SalesInvoiceService } from "../../../services";
import { WhWorkOrderService } from "../../../services/whWorkOrder.service";

@Component({
  selector: "addWhWorkOrder",
  templateUrl: "./addWhWorkOrder.html",
})
export class addWhWorkOrder {
  data: any;
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  isLoadMask: Promise<any>;

  // typeList = ['Party Wise', 'Rgrn Wise', 'Design Wise', 'Style Wise'];
  typeList = ['Party Wise', 'Design Wise', 'Rgrn Wise'];
  partyList: any[] = [];
  styleList: string[] = ["FORMAL", "CASUAL", "RR FORMAL", "RR CASUAL"];
  varietyList: any[] = [];
  rgrnList: any[] = [];
  onsaveDisable : boolean = false;

  formData = {
    "whWorkOrderID": "",
    "type": "",
    "partyName": "",
    "partyID": "",
    "style": "",
    "variety": "",
    "varietyID": "",
    "designNo": "",
    "rgrnDate": null,
    "rgrnDesignNos": null,
    "assignedQty": 0
  };
  isFormDataSubmitted = false;

  allPendingOrderData = [];
  pendingOrderData = [];
  pendingOrderSetsData = [];
  pendingOrderMismatchSetsData = [];
  pendingOrderSizesData = [];
  setAndSizeList = {};
  stocks = {};
  uniqueStockSets = [];

  summary = {
    pieces: {
      fs: 0,
      hs: 0,
      total: 0,
      totalSets: 0,
      totalSizes: 0
    },
    exact: {
      stock: { total: 0 },
      assigned: { fs: 0, hs: 0, total: 0 }
    },
    mismatch: {
      stock: { total: 0 },
      assigned: { fs: 0, hs: 0, total: 0 }
    },
    size: {
      stock: { total: 0 },
      assigned: { fs: 0, hs: 0, total: 0 }
    }
  }

  @Input() set params(val: any[]) {
    this.mode = val["mode"];
    let data = Object.assign({}, val["data"]);
    this.data = data;
    console.log('data :: ', this.data);
    this.saveEvent = val["data"].tabevent;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    public MappingService: MenuMappingService,
    private salesinvservice: SalesInvoiceService,
    private combo: Combo2Service,
    private whWorkOrderService: WhWorkOrderService
  ) {
    this.data = {}
  }
  ngOnInit() {
    this.getPartyList();
  }

  ngAfterViewInit() {
    // $("#invoice_type").focus();
  }

  getPartyList() {
    let params = { start: 0, limit: 100, page: 1 };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  getVarietyList() {
    this.formData.variety = '';
    this.formData.varietyID = '';

    this.combo.varietyStylePoCombo({ style: this.formData.style, page: 'WH Work Order' }).then((res: any) => {
      let list = [...res.data];

      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);
    });
  }

  getRgrnList() {
    if (!this.formData.rgrnDate) {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "warning",
        title: "WARNING",
        body: "Please select date first",
      });
    }

    this.formData.rgrnDesignNos = [];
    const date = new Date(this.formData.rgrnDate);
    const dateStr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    this.whWorkOrderService.getRgrnList({ rgrnDate: dateStr }).then((res: any) => {
      this.rgrnList = res.data.map(x => x.design_no);
      console.log("rgrnList :: ", this.rgrnList);
    });
  }

  partyOnSelect(ev: any) {
    this.formData.partyID = ev.item.genLedid || '';
  }

  varietyOnSelect(ev: any) {
    const varietyID = this.varietyList.find(x => x.variety === ev).st_id;
    this.formData.varietyID = varietyID;
  }

  rgrnDateOnSelect(ev: any) {
    this.getRgrnList();
  }

  buttonStyle() {
    const style = {
      Position: "relative",
      left: this.mode == "Add" ? "90%" : "73% !important",
      bottom: "54px"
    };
    return style;
  }

  validateFormData(): boolean {
    let errorMessage = '';

    // Common required fields
    // if (!this.formData.username) {
    //   errorMessage = 'User Name is required';
    // } else 
    if (!this.formData.type) {
      errorMessage = 'Type is required';
    }
    //  else if (!this.formData.assignedQty) {
    //   errorMessage = 'Assign Qty is required';
    // }

    // Type-based validations
    if (!errorMessage) {
      switch (this.formData.type) {
        case 'Party Wise':
          if (!this.formData.partyName) {
            errorMessage = 'Party is required';
          }
          break;

        case 'Designno Wise':
          if (!this.formData.designNo) {
            errorMessage = 'Design is required';
          }
          break;

        case 'Style Wise':
          if (!this.formData.style) {
            errorMessage = 'Style is required';
          }
          break;

        case 'Rgrn Wise':
          if (!this.formData.rgrnDate) {
            errorMessage = 'Rgrn date is required';
          } else if (!this.formData.designNo) {
            errorMessage = 'Rgrn design selection is required';
          }
          break;
      }
    }

    // Show error if any
    if (errorMessage) {
      swal('ERROR', errorMessage, 'error');
      return false;
    }

    return true;
  }

  clearUnwantedFormData(): void {
    const type = this.formData.type;

    const clearMap = {
      'Party Wise': ['rgrnDate', 'rgrnDesignNos'],
      'Design Wise': ['partyName', 'partyID', 'style', 'variety', 'varietyID', 'rgrnDate', 'rgrnDesignNos'],
      'Style Wise': ['partyName', 'partyID', 'rgrnDate', 'rgrnDesignNos'],
      'Rgrn Wise': ['partyName', 'partyID', 'style', 'variety', 'varietyID', 'designNo']
    };

    const fieldsToClear = clearMap[type] || [];

    for (const key of fieldsToClear) {
      this.formData[key] = null;
    }
  }

  submit() {
    let that = this;
    // const isValidFormData = this.validateFormData();

    // if (!isValidFormData) {
    //   return;
    // }

    // this.clearUnwantedFormData();

    const formData = JSON.parse(JSON.stringify(this.formData));
    console.log("formData :: ", formData);
    formData.assignedQty = this.summary.pieces.total;

    formData.pendingOrder = JSON.stringify(this.pendingOrderData);
    // formData.stocks = this.stocks;

    swal({
      title: "Are you sure to save?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;

      that.isLoadMask = that.whWorkOrderService
        .saveUpdateWhWorkOrder(formData)
        .then(function (res: any) {
          that.isLoading = false;
            that.onsaveDisable = true;
          if (res.message == "Access Denied") {
            swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
            return false
          }
          else {
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
                that.onsaveDisable = false;
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              swal("ERROR", res.message, "error");
            }
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          that.isLoading = false;
        });
    });
  }

  fetchPartyWisePendingDetails() {
    const isValidFormData = this.validateFormData();

    if (!isValidFormData) {
      return;
    }

    // this.clearUnwantedFormData();

    const formData = JSON.parse(JSON.stringify(this.formData));
    console.log("formData :: ", formData);

    this.whWorkOrderService.fetchPartyWisePendingDetails(formData).then((res: any) => {
      const pendingOrderData = res.data;
      this.setAndSizeList = {
        sets: res.uniqueSets,
        sizes: res.uniqueSizes
      }

      this.allPendingOrderData = pendingOrderData;
      console.log("pendingOrderData :: ", this.allPendingOrderData);

      const uniqueDesignNos = this.getUniqueDesignNos(this.allPendingOrderData);
      this.getStocks(uniqueDesignNos);
    });
  }

  getUniqueDesignNos(data) {
    const seen = {};
    const unique = [];

    for (let i = 0; i < data.length; i++) {
      const designNo = data[i].design_no;
      if (!seen[designNo]) {
        seen[designNo] = true;
        unique.push(designNo);
      }
    }

    return unique;
  }

  getStocks(designNos: string[]) {
    this.whWorkOrderService.getStockByDesignNos(designNos).then((res: any) => {
      this.stocks = res.data || [];
      console.log("stocks :: ", this.stocks);
      const uniqueSets = Array.from(new Set((res.sets || []).map(item => item.set)));
      this.uniqueStockSets = uniqueSets;
      console.log("uniqueStockSets :: ", this.uniqueStockSets);
      this.filterPendingOrderRows();
    });
  }

  filterPendingOrderRows() {
    this.pendingOrderData = this.allPendingOrderData;

    // Filter based on type
    if (this.formData.type === 'Party Wise') {
      this.pendingOrderData = this.allPendingOrderData.filter(x => {
        return Boolean(this.stocks[x.design_id]);
      });
    } else {
      this.pendingOrderData = this.allPendingOrderData;
    }

    // Create arrays to store references (not copies) of filtered data
    this.pendingOrderSetsData = [];
    this.pendingOrderSizesData = [];
    this.pendingOrderMismatchSetsData = [];

    // Filter based on PENDING ORDERS - what the user actually ordered
    this.pendingOrderData.forEach(orderItem => {
      const stockObj = this.stocks[orderItem.design_id];

      // FOR SETS TAB: Only add rows that have pending SET orders (original condition)
      if (orderItem.sets && Object.keys(orderItem.sets).length > 0) {
        // Verify there's stock available for at least one pending set
        const hasSetStock = stockObj && stockObj.sets &&
          Object.keys(orderItem.sets).some(setKey => {
            return stockObj.sets[setKey] && stockObj.sets[setKey].stock > 0;
          });

        if (hasSetStock) {
          this.pendingOrderSetsData.push(orderItem);
        }
      }

      // FOR MISMATCH SETS TAB: Add rows that have sets and matching sleeve_type in stock
      if (orderItem.sets && Object.keys(orderItem.sets).length > 0) {
        // Check if there's stock available with matching sleeve type
        const hasMismatchSetStock = stockObj && stockObj.sets &&
          Object.keys(stockObj.sets).some(stockSetKey => {
            const stockSet = stockObj.sets[stockSetKey];
            return stockSet.sleeve === orderItem.sleeve_type && stockSet.stock > 0;
          });

        if (hasMismatchSetStock) {
          this.pendingOrderMismatchSetsData.push(orderItem);
        }
      }

      // FOR SIZES TAB: Only add rows that have pending SIZE orders (original condition)
      if (orderItem.sizes && Object.keys(orderItem.sizes).length > 0) {
        // Verify there's stock available for at least one pending size
        const hasSizeStock = stockObj && stockObj.sizes &&
          Object.keys(orderItem.sizes).some(sizeKey => {
            return stockObj.sizes[sizeKey] && stockObj.sizes[sizeKey].stock > 0;
          });

        if (hasSizeStock) {
          this.pendingOrderSizesData.push(orderItem);
        }
      }
    });

    if (this.pendingOrderData.length) {
      this.isFormDataSubmitted = true;
    }

    console.log("=== FILTERING RESULTS ===");
    console.log("Total pendingOrderData :: ", this.pendingOrderData.length);
    console.log("Filtered pendingOrderSetsData :: ", this.pendingOrderSetsData.length);
    console.log("Filtered pendingOrderSizesData :: ", this.pendingOrderSizesData.length);
    console.log("Filtered pendingOrderMismatchSetsData :: ", this.pendingOrderMismatchSetsData.length);
    console.log("pendingOrderSetsData :: ", this.pendingOrderSetsData);
    console.log("pendingOrderSizesData :: ", this.pendingOrderSizesData);
    console.log("pendingOrderMismatchSetsData :: ", this.pendingOrderMismatchSetsData);
  }

  // filterPendingOrderRows() {
  //   this.pendingOrderData = this.allPendingOrderData;
  //   this.pendingOrderSetsData = this.pendingOrderData;
  //   this.pendingOrderSizesData = this.pendingOrderData;
  // }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/phase1/WhWorkOrder/addWhWorkOrder.ts